import { useEffect, useRef } from 'react';

export const useScrollToView = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.scrollIntoView) {
      ref.current.scrollIntoView();
    }
  }, [ref]);

  return ref;
};
